import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

import { TableAdapter } from '@makyoapp/makyo-common'
import { MoreVert24, Table16 } from '@makyoapp/makyo-icon/icon'
import { SelectDropdown } from '@makyoapp/makyo-ui'

import { RenderColumnCustom } from '../RenderColumn'

interface TableDdProps {
  /**
   * html id
   */
  id: string
  toggleClassName?: string
  value: string
  onChange: (value: string) => void
  tables: TableAdapter[]
}

export function TableDd({ id, toggleClassName, tables, value, onChange }: TableDdProps) {
  const { t } = useTranslation()

  const opts = useMemo(() => {
    return [{ id: '', name: t('Select Table') }, ...tables]
  }, [tables, t])

  return (
    <SelectDropdown
      className='w-full'
      id={id}
      menuDefaultSize={false}
      menuClassName={'max-h-[220px] overflow-y-auto'}
      menuContainerClassName='mk-ag-sdd'
      toggleClassName={clsx(toggleClassName)}
      menuHeadingClassName='px-4! py-2 text-light border-t bdr'
      menuZIndex='z-305'
      value={tables.find((tb) => tb.id === value)}
      onChange={(opt) => {
        onChange(opt.id)
      }}
      optionLabel={(opt) => opt.name}
      withSearch
      portalMenu
      customArrow={<MoreVert24 width={16} height={16} />}
      renderOption={(opt) => {
        if (!opt) {
          return null
        }
        return <RenderColumnCustom name={opt.name} icon={<Table16 className={'fill-primary-500'} />} />
      }}
      options={opts}
    />
  )
}
